import React, { useEffect, useState } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import TextField from '@material-ui/core/TextField'
import InputAdornment from '@material-ui/core/InputAdornment'
import IconButton from '@material-ui/core/IconButton'
import Visibility from '@material-ui/icons/Visibility'
import VisibilityOff from '@material-ui/icons/VisibilityOff'
import Field, { messageIdFor } from 'components/ds/Field'
import Icon from 'components/ds/Icon'

const ChevronDown = (props) => <Icon name="chevron-down" size={18} {...props} />

const TextFieldForm = ({
  name,
  id,
  label,
  type = 'text',
  variant = 'outlined',
  defaultValue,
  InputLabelProps = {},
  placeholder,
  readOnly = false,
  required = false,
  optional = false,
  disabled = false,
  helperText,
  error: customError = false,
  multiline = false,
  rows = 4,
  inputRef,
  select = false,
  fullWidth = false,
  showPasswordIcon = false,
  children,
  startAdornment,
  endAdornment,
  className,
  inputClassName,
  onKeyDown = () => {},
  validate,
  maxLength,
  minLength,
  pattern,
  onChange: onChangeProp,
  onBlur: onBlurProp,
  SelectProps,
  margin = 'normal',
  InputProps: additionalInputProps = {},
  size = 'small',
}) => {
  const { control } = useFormContext()
  const [customType, setCustomType] = useState(type)
  const [showPassword, setShowPassword] = useState(false)


  useEffect(() => {
    if (showPassword) {
      setCustomType('text')
    } else if (showPasswordIcon) {
      setCustomType('password')
    } else {
      setCustomType(type)
    }
  }, [showPassword, showPasswordIcon, type])

  const isRequired = required ? 'Field is required' : false

  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required: isRequired,
        validate: validate,
        maxLength: maxLength,
        minLength: minLength,
        pattern: pattern,
      }}
      render={({ field: { onChange, onBlur, value = '', ref }, fieldState: { error } }) => {
        const fieldId = id || name.toLowerCase().replace(/\s/g, '')
        const message = error?.message || helperText
        return (
        <Field
          id={fieldId}
          label={label}
          required={required}
          hint={error?.message ? undefined : (helperText || (optional ? 'Optional' : undefined))}
          error={error?.message}
          className={className}
        >
        <TextField
          id={fieldId}
          className={inputClassName}
          fullWidth={fullWidth}
          placeholder={placeholder}
          type={customType}
          select={select}
          inputRef={inputRef || ref}
          defaultValue={defaultValue}
          value={value}
          size={size}
          onChange={(e) => {
            onChange(e)
            if (onChangeProp) onChangeProp(e)
          }}
          onBlur={(e) => {
            onBlur(e)
            if (onBlurProp) onBlurProp(e)
          }}
          onKeyDown={onKeyDown}
          variant={variant}
          disabled={disabled}
          error={Boolean(error) || customError}
          multiline={multiline}
          minRows={rows}
          margin={margin}
          aria-describedby={message ? messageIdFor(fieldId) : undefined}
          SelectProps={{ IconComponent: ChevronDown, ...SelectProps }}
          InputProps={{
            readOnly: readOnly,
            startAdornment: startAdornment && (
              <InputAdornment position="start">{startAdornment}</InputAdornment>
            ),
            endAdornment: (showPasswordIcon || endAdornment) && !select && (
              <InputAdornment position="end" style={{marginRight:"1rem"}}>
                {showPasswordIcon ? (
                  <IconButton type="button" onClick={() => setShowPassword(!showPassword)} edge="end">
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                ) : (
                  endAdornment
                )}
              </InputAdornment>
            ),
            ...additionalInputProps,
          }}
        >
          {children}
        </TextField>
        </Field>
        )
      }}
    />
  )
}

export default TextFieldForm
